import { render, staticRenderFns } from "./offline_order_batch_record_detail.vue?vue&type=template&id=00b6cede&scoped=true"
import script from "./offline_order_batch_record_detail.vue?vue&type=script&lang=js"
export * from "./offline_order_batch_record_detail.vue?vue&type=script&lang=js"
import style0 from "../css/common.less?vue&type=style&index=0&id=00b6cede&prod&lang=less&scoped=true&external"
import style1 from "./offline_order_batch_record_detail.vue?vue&type=style&index=1&id=00b6cede&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b6cede",
  null
  
)

export default component.exports